export const useTemplateFontSettings = () => {
    const dshReviewBackgroundcolor = "#E5F3FD";
    const dshVoteBackgroundcolor = "#E8ECE4";
    const dshVideoBackgroundcolor = "#FFF0F5";
    const dshPreviousBackgroundcolor = "#FFF3E0";

    const dshReviewChip = '#3F88C5';
    const dshVoteChip = '#5A8F57';
    const dshVideoChip = '#c2185b';
    const dshPreviousChip = '#F57C00';

    const tableCellStyle = {};
    const paginationStyle = {};
    // Eski ikon buton aralığı: 1px boşluk, taban ikon ölçüsü kadar (tema ikonuna uyum).
    const buttonStyle = { p: '1px', minWidth: (theme) => theme.components?.MuiSvgIcon?.styleOverrides?.root?.fontSize || 18 };
    const listItemStyle = {
        '&:hover .ListItemIcons': { opacity: 1 },
        justifyContent: 'center',
        padding: 0,
    };
    const fabStyle = {};
    const smallfabStyle = {
        width: '20px',
        height: '20px',
    };

    return {
        tableCellStyle,
        paginationStyle,
        buttonStyle,
        listItemStyle,
        fabStyle,
        smallfabStyle,
        dshReviewBackgroundcolor,
        dshVoteBackgroundcolor,
        dshVideoBackgroundcolor,
        dshPreviousBackgroundcolor,
        dshReviewChip,
        dshVoteChip,
        dshVideoChip,
        dshPreviousChip,
    };
};
